// ============================================
// NEXUS PEN - Main JavaScript (Polished)
// ============================================

// Wrapped in a named init with a readyState guard instead of a bare
// DOMContentLoaded listener: with warm-cache timing this deferred file can
// finish loading AFTER DOMContentLoaded has already fired, and a listener
// registered then never runs — which silently killed every binding in this
// block (video modal, reveals, toggles) for repeat visitors.
const npMainInit = () => {

  // ---- Mobile menu toggle (handled by slide-in overlay section below) ----
  const mobileToggle = document.getElementById('mobileToggle');
  const mobileMenu = document.getElementById('mobileMenu');

  // ---- Navbar scroll effect ----
  const navbar = document.getElementById('navbar');
  let lastScroll = 0;
  if (navbar) {
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      if (currentScroll > 50) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // ---- Theme toggle (dark/light) ----
  // FOUC-prevention script in <head> already set data-theme from localStorage.
  // This wires up the click handler and keeps aria-label in sync.
  (function () {
    var btn = document.getElementById('themeToggle');
    if (!btn) return;
    var root = document.documentElement;
    function syncLabel() {
      var isLight = root.getAttribute('data-theme') === 'light';
      btn.setAttribute('aria-label', isLight ? 'Switch to dark mode' : 'Switch to light mode');
      btn.setAttribute('title',      isLight ? 'Switch to dark mode' : 'Switch to light mode');
    }
    syncLabel();
    btn.addEventListener('click', function () {
      var next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
      root.setAttribute('data-theme', next);
      try { localStorage.setItem('np-theme', next); } catch (e) { /* ignore */ }
      syncLabel();
    });
  })();

  // ---- FAQ accordion (smooth) ----
  document.querySelectorAll('.faq-item').forEach(item => {
    const answer = item.querySelector('.faq-answer');
    if (answer) {
      // Set initial state
      answer.style.maxHeight = '0';
      answer.style.overflow = 'hidden';
      answer.style.opacity = '0';
      answer.style.transition = 'max-height 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease, margin 0.3s ease';
      answer.style.marginTop = '0';
    }

    item.addEventListener('click', () => {
      const isOpen = item.classList.contains('faq-open');

      // Close all
      document.querySelectorAll('.faq-item').forEach(other => {
        const otherAnswer = other.querySelector('.faq-answer');
        if (otherAnswer) {
          other.classList.remove('faq-open');
          otherAnswer.style.maxHeight = '0';
          otherAnswer.style.opacity = '0';
          otherAnswer.style.marginTop = '0';
        }
      });

      // Toggle clicked
      if (!isOpen && answer) {
        item.classList.add('faq-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        answer.style.opacity = '1';
        answer.style.marginTop = '12px';
      }
    });
  });

  // ---- Plan toggle (Personal / Business) ----
  const planToggles = document.querySelectorAll('.plan-toggle .toggle-btn');
  const personalPlans = document.getElementById('personalPlans');
  const businessPlans = document.getElementById('businessPlans');

  function fadeSwitch(show, hide) {
    if (!show || !hide) return;
    hide.style.display = 'none';
    show.style.display = 'grid';
  }

  planToggles.forEach(btn => {
    btn.addEventListener('click', () => {
      planToggles.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const target = btn.dataset.target;
      if (target === 'personal') {
        fadeSwitch(personalPlans, businessPlans);
      } else {
        fadeSwitch(businessPlans, personalPlans);
      }
    });
  });

  // ---- Billing toggle (Monthly / Annual) ----
  const billingBtns = document.querySelectorAll('.billing-toggle .billing-btn');
  billingBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      billingBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const billing = btn.dataset.billing;
      document.querySelectorAll('.price-monthly').forEach(el => {
        el.style.display = billing === 'monthly' ? 'block' : 'none';
      });
      document.querySelectorAll('.price-annual').forEach(el => {
        el.style.display = billing === 'annual' ? 'block' : 'none';
      });
    });
  });

  // ---- Smooth scroll for anchor links ----
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const navHeight = navbar ? navbar.offsetHeight : 0;
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - navHeight - 20;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
        if (mobileMenu) mobileMenu.classList.remove('open');
        if (mobileToggle) mobileToggle.classList.remove('active');
      }
    });
  });

  // ---- Video Modal ----
  const videoModal = document.getElementById('videoModal');
  const videoModalIframe = document.getElementById('videoModalIframe');
  const videoModalClose = document.getElementById('videoModalClose');
  const videoModalOverlay = document.getElementById('videoModalOverlay');

  // Delegated on document (was a per-element forEach): clicking "Watch Demo"
  // was navigating to /pages/donna-demo instead of opening the modal — the
  // per-element listener wasn't on the live node at click time. Delegation
  // catches the click no matter when or how the trigger was (re)rendered.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-video-modal]');
    if (!trigger) return;
    const videoId = trigger.dataset.videoModal;
    if (videoModal && videoModalIframe && videoId) {
      e.preventDefault();
      videoModalIframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      videoModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  });

  function closeVideoModal() {
    if (videoModal && videoModalIframe) {
      videoModal.classList.remove('active');
      document.body.style.overflow = '';
      setTimeout(() => {
        videoModalIframe.src = '';
      }, 350);
    }
  }

  if (videoModalClose) videoModalClose.addEventListener('click', closeVideoModal);
  if (videoModalOverlay) videoModalOverlay.addEventListener('click', closeVideoModal);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeVideoModal();
  });

  // ---- Quantity selector for product pages ----
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('input');
    const minus = selector.querySelector('[data-action="minus"]');
    const plus = selector.querySelector('[data-action="plus"]');
    if (minus && plus && input) {
      minus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
      plus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  // ---- Mobile menu toggle (CSP-safe — Shopify blocks inline onclick) ----
  if (mobileToggle && mobileMenu) {
    const overlay = document.querySelector('.mobile-menu-overlay');
    const closeBtn = document.querySelector('.mobile-menu-close');
    const openMenu = () => {
      mobileMenu.classList.add('open');
      mobileToggle.classList.add('active');
      mobileMenu.style.setProperty('transform', 'translateX(0)', 'important');
      mobileMenu.style.setProperty('visibility', 'visible', 'important');
      if (overlay) {
        overlay.classList.add('active');
        overlay.style.setProperty('display', 'block', 'important');
        overlay.style.setProperty('opacity', '1', 'important');
        overlay.style.setProperty('visibility', 'visible', 'important');
      }
      document.body.style.overflow = 'hidden';
      mobileToggle.setAttribute('aria-expanded', 'true');
    };
    const closeMenu = () => {
      mobileMenu.classList.remove('open');
      mobileToggle.classList.remove('active');
      mobileMenu.style.removeProperty('transform');
      mobileMenu.style.removeProperty('visibility');
      if (overlay) {
        overlay.classList.remove('active');
        overlay.style.removeProperty('display');
        overlay.style.removeProperty('opacity');
        overlay.style.removeProperty('visibility');
      }
      document.body.style.overflow = '';
      mobileToggle.setAttribute('aria-expanded', 'false');
    };
    mobileToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      mobileMenu.classList.contains('open') ? closeMenu() : openMenu();
    });
    if (overlay) overlay.addEventListener('click', closeMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) closeMenu();
    });
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
  }

  // ---- Product thumbnail switcher ----
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mainImg = document.querySelector('#mainProductImage img');
      if (mainImg && thumb.dataset.img) {
        mainImg.src = thumb.dataset.img;
        if (thumb.dataset.alt) mainImg.alt = thumb.dataset.alt;
        document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

  // ---- Plan URL pre-selection on contact page ----
  const urlParams = new URLSearchParams(window.location.search);
  const planParam = urlParams.get('plan');
  if (planParam) {
    const subjectSelect = document.querySelector('select[name="contact[subject]"]');
    if (subjectSelect) {
      const planMap = {
        'free': 'Free Plan Interest',
        'plus': 'Plus Plan Interest',
        'pro': 'Pro Plan Interest',
        'team': 'Team Plan Interest',
        'school': 'School Plan Interest',
        'enterprise': 'Enterprise Plan Interest'
      };
      const value = planMap[planParam.toLowerCase()];
      if (value) {
        for (let option of subjectSelect.options) {
          if (option.value === value) {
            option.selected = true;
            break;
          }
        }
      }
    }
  }

  // ---- Lazy loading images ----
  if ('loading' in HTMLImageElement.prototype) {
    document.querySelectorAll('img[loading="lazy"]').forEach(img => {
      if (img.dataset.src) img.src = img.dataset.src;
    });
  }

  // ---- AJAX Add to Cart ----
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"]');
      const originalHTML = submitBtn ? submitBtn.innerHTML : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(item => {
        if (submitBtn) {
          submitBtn.innerHTML = '<i class="fas fa-check"></i> Added!';
          setTimeout(() => {
            submitBtn.innerHTML = originalHTML;
            submitBtn.disabled = false;
          }, 1500);
        }
        // Update cart count in header
        fetch('/cart.js').then(r => r.json()).then(cart => {
          document.querySelectorAll('.cart-count').forEach(el => {
            el.textContent = cart.item_count;
            el.style.display = 'flex';
          });
          // If no cart-count element exists, create one
          if (!document.querySelector('.cart-count')) {
            const cartIcon = document.querySelector('.cart-icon');
            if (cartIcon) {
              const badge = document.createElement('span');
              badge.className = 'cart-count';
              badge.textContent = cart.item_count;
              cartIcon.appendChild(badge);
            }
          }
        });
        // Show toast notification
        showCartToast(item.product_title);
      })
      .catch(() => {
        if (submitBtn) {
          submitBtn.innerHTML = originalHTML;
          submitBtn.disabled = false;
        }
      });
    });
  });

  function showCartToast(productTitle) {
    // Remove existing toast
    const existing = document.querySelector('.cart-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.innerHTML = `
      <span class="cart-toast-icon"><i class="fas fa-check-circle"></i></span>
      <span class="cart-toast-text"><strong>Added to cart</strong>${productTitle}</span>
      <a href="/cart" class="cart-toast-action">View Cart <i class="fas fa-arrow-right"></i></a>
    `;
    document.body.appendChild(toast);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        toast.classList.add('show');
      });
    });
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 400);
    }, 4000);
  }

  // ---- AJAX Cart Quantity Updates ----
  document.querySelectorAll('.cart-item .cart-qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.cart-qty-input');
      const line = parseInt(input.dataset.line);
      let qty = parseInt(input.value) || 1;

      if (btn.dataset.action === 'minus') {
        qty = Math.max(0, qty - 1);
      } else {
        qty = qty + 1;
      }
      input.value = qty;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(res => res.json())
      .then(() => {
        // Reload to reflect updated prices
        window.location.reload();
      });
    });
  });

  // Cart quantity input direct change
  document.querySelectorAll('.cart-qty-input').forEach(input => {
    let debounce;
    input.addEventListener('change', () => {
      clearTimeout(debounce);
      const line = parseInt(input.dataset.line);
      const qty = Math.max(0, parseInt(input.value) || 0);
      input.value = qty;

      debounce = setTimeout(() => {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        })
        .then(res => res.json())
        .then(() => {
          window.location.reload();
        });
      }, 300);
    });
  });

  // Cart remove buttons (AJAX)
  document.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const line = parseInt(btn.dataset.line);
      const item = btn.closest('.cart-item');
      if (item) {
        item.style.opacity = '0';
        item.style.transform = 'translateX(20px)';
        item.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
      .then(res => res.json())
      .then(() => {
        window.location.reload();
      });
    });
  });

  // ---- Sticky Buy Bar ----
  const stickyBar = document.getElementById('stickyBuyBar');
  if (stickyBar) {
    const heroSection = document.querySelector('.hero');
    if (heroSection) {
      window.addEventListener('scroll', () => {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        if (heroBottom < 0) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      }, { passive: true });
    }
  }

  // ---- Mobile menu slide-in overlay ----
  if (mobileToggle && mobileMenu) {
    // Create overlay element
    const menuOverlay = document.createElement('div');
    menuOverlay.className = 'mobile-menu-overlay';
    document.body.appendChild(menuOverlay);

    const openMenu = () => {
      mobileMenu.classList.add('open');
      mobileToggle.classList.add('active');
      menuOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    };
    const closeMenu = () => {
      mobileMenu.classList.remove('open');
      mobileToggle.classList.remove('active');
      menuOverlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    // Replace old toggle listener (add fresh one)
    mobileToggle.addEventListener('click', () => {
      if (mobileMenu.classList.contains('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
    menuOverlay.addEventListener('click', closeMenu);

    // Close mobile menu when any link is clicked
    document.querySelectorAll('.mobile-menu .nav-link').forEach(link => {
      link.addEventListener('click', closeMenu);
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) closeMenu();
    });
  }

}; // end npMainInit
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', npMainInit);
} else {
  npMainInit();
}

// ============================================
// NEXUS PEN - Account Dashboard (tabs, API)
// ============================================

// ---- Conversations ----
var _convPage = 0;
var _convLoaded = false;
var _convAll = [];

function initConversations() {
  if (_convLoaded) return;
  loadConversations();
}

async function loadConversations() {
  var token = window._npToken;
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';

  var loading = document.getElementById('conv-loading');
  var errorEl = document.getElementById('conv-error');
  var noAuth = document.getElementById('conv-no-auth');
  var listEl = document.getElementById('conv-list');
  var emptyEl = document.getElementById('conv-empty');
  var loadMore = document.getElementById('conv-load-more');

  if (!token) {
    if (loading) loading.style.display = 'none';
    if (noAuth) noAuth.style.display = 'block';
    return;
  }

  if (loading) loading.style.display = 'block';
  if (errorEl) errorEl.style.display = 'none';
  if (listEl) listEl.style.display = 'none';
  if (emptyEl) emptyEl.style.display = 'none';
  if (loadMore) loadMore.style.display = 'none';

  try {
    var apiFetch = window._npApiFetch;
    var res = apiFetch
      ? await apiFetch('/api/history?limit=20&offset=0')
      : await fetch(API_BASE + '/api/history?limit=20&offset=0', { headers: { 'Authorization': 'Bearer ' + token } });

    if (!res.ok) throw new Error('fetch failed');
    var data = await res.json();
    var raw = Array.isArray(data) ? data : (data.conversations || data.items || []);
    // Map /api/history fields to renderConversations format
    var convs = raw.map(function(c) {
      return {
        title: c.title || c.user_message || c.first_message || 'Conversation',
        preview: c.assistant_response || c.preview || c.last_message || '',
        mode: c.mode || c.query_type || '',
        created_at: c.created_at || c.timestamp || '',
        user_message: c.user_message || '',
        assistant_response: c.assistant_response || ''
      };
    });
    _convAll = convs;
    _convPage = 1;
    _convLoaded = true;

    if (loading) loading.style.display = 'none';

    if (convs.length === 0) {
      if (emptyEl) emptyEl.style.display = 'block';
      return;
    }

    renderConversations(convs);
    if (listEl) listEl.style.display = 'block';
    if (convs.length >= 20 && loadMore) loadMore.style.display = 'block';

    // Search binding
    var searchEl = document.getElementById('conv-search');
    if (searchEl) {
      searchEl.addEventListener('input', function() {
        var q = this.value.toLowerCase();
        var filtered = q ? _convAll.filter(function(c) {
          return (c.title || c.user_message || c.preview || '').toLowerCase().includes(q);
        }) : _convAll;
        renderConversations(filtered);
      });
    }
  } catch(e) {
    if (loading) loading.style.display = 'none';
    if (errorEl) errorEl.style.display = 'block';
  }
}

async function loadMoreConversations() {
  var token = window._npToken;
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';
  var btn = document.getElementById('conv-load-more-btn');
  if (btn) { btn.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> Loading...'; btn.disabled = true; }

  try {
    var apiFetch = window._npApiFetch;
    var offset = _convPage * 20;
    var res = apiFetch
      ? await apiFetch('/api/history?limit=20&offset=' + offset)
      : await fetch(API_BASE + '/api/history?limit=20&offset=' + offset, { headers: { 'Authorization': 'Bearer ' + token } });

    if (!res.ok) throw new Error('failed');
    var data = await res.json();
    var more = Array.isArray(data) ? data : (data.conversations || data.items || []);
    _convAll = _convAll.concat(more);
    _convPage++;
    renderConversations(_convAll);
    var loadMore = document.getElementById('conv-load-more');
    if (more.length < 20 && loadMore) loadMore.style.display = 'none';
  } catch(e) {}

  if (btn) { btn.innerHTML = '<i class="fas fa-chevron-down"></i> Load More'; btn.disabled = false; }
}

function renderConversations(convs) {
  var listEl = document.getElementById('conv-list');
  if (!listEl) return;
  if (convs.length === 0) {
    listEl.innerHTML = '<div class="dash-empty-state"><i class="fas fa-search-minus"></i><p>No matching conversations.</p></div>';
    return;
  }
  listEl.innerHTML = convs.map(function(c) {
    var title = c.title || c.summary || c.first_message || 'Conversation';
    var date = c.created_at || c.timestamp || c.date || '';
    var dateStr = date ? new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
    var mode = c.mode || c.ai_mode || '';
    var msgCount = c.message_count || c.messages || '';
    var preview = c.preview || c.last_message || c.summary || '';
    return '<div class="conv-card" onclick="toggleConvDetail(this)">' +
      '<div class="conv-card-header">' +
        '<div class="conv-card-left">' +
          (mode ? '<span class="conv-mode-tag">' + escHtml(mode) + '</span>' : '') +
          '<span class="conv-title">' + escHtml(title) + '</span>' +
        '</div>' +
        '<div class="conv-card-right">' +
          (dateStr ? '<span class="conv-date">' + dateStr + '</span>' : '') +
          (msgCount ? '<span class="conv-count"><i class="fas fa-comment"></i> ' + msgCount + '</span>' : '') +
          '<i class="fas fa-chevron-down conv-chevron"></i>' +
        '</div>' +
      '</div>' +
      (preview ? '<div class="conv-preview">' + escHtml(preview) + '</div>' : '') +
      '<div class="conv-detail" style="display:none;">' +
        (c.messages_list ? renderMessagesList(c.messages_list) : '<p class="conv-detail-note">Open the Nexus Pen app to view full transcript.</p>') +
      '</div>' +
    '</div>';
  }).join('');
}

function toggleConvDetail(card) {
  var detail = card.querySelector('.conv-detail');
  var chevron = card.querySelector('.conv-chevron');
  var isOpen = card.classList.contains('conv-open');
  // Close all
  document.querySelectorAll('.conv-card.conv-open').forEach(function(c) {
    c.classList.remove('conv-open');
    var d = c.querySelector('.conv-detail');
    var ch = c.querySelector('.conv-chevron');
    if (d) d.style.display = 'none';
    if (ch) ch.style.transform = '';
  });
  if (!isOpen) {
    card.classList.add('conv-open');
    if (detail) detail.style.display = 'block';
    if (chevron) chevron.style.transform = 'rotate(180deg)';
  }
}

function renderMessagesList(msgs) {
  if (!Array.isArray(msgs) || msgs.length === 0) return '<p class="conv-detail-note">No messages to display.</p>';
  return '<div class="conv-messages">' + msgs.slice(0, 10).map(function(m) {
    var role = m.role || m.sender || 'user';
    var text = m.content || m.text || '';
    return '<div class="conv-msg conv-msg-' + role + '"><span class="conv-msg-role">' + role + '</span><span class="conv-msg-text">' + escHtml(text) + '</span></div>';
  }).join('') + '</div>';
}

function escHtml(str) {
  if (str === null || str === undefined || str === '') return '';
  return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

// ---- Family / Org ----
var _familyLoaded = false;

function initFamily() {
  if (_familyLoaded) return;
  loadFamilyGroup();
}

async function loadFamilyGroup() {
  var token = window._npToken;
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';

  var loading = document.getElementById('family-loading');
  var noAuth = document.getElementById('family-no-auth');
  var content = document.getElementById('family-content');
  var errorEl = document.getElementById('family-error');
  var noGroup = document.getElementById('family-no-group');
  var groupPanel = document.getElementById('family-group-panel');
  var roleBadge = document.getElementById('family-role-badge');

  if (!token) {
    if (loading) loading.style.display = 'none';
    if (noAuth) noAuth.style.display = 'block';
    return;
  }

  if (loading) loading.style.display = 'block';
  if (content) content.style.display = 'none';
  if (errorEl) errorEl.style.display = 'none';

  try {
    var apiFetch = window._npApiFetch;
    var res = apiFetch
      ? await apiFetch('/api/family')
      : await fetch(API_BASE + '/api/family', { headers: { 'Authorization': 'Bearer ' + token } });

    if (loading) loading.style.display = 'none';

    if (res.status === 404 || res.status === 204) {
      if (content) content.style.display = 'block';
      if (noGroup) noGroup.style.display = 'block';
      if (groupPanel) groupPanel.style.display = 'none';
      _familyLoaded = true;
      return;
    }

    if (!res.ok) throw new Error('failed');
    var data = await res.json();
    _familyLoaded = true;

    // Backend returns {family_group, members}
    var group = data.family_group;
    var members = data.members || [];

    if (!group) {
      if (content) content.style.display = 'block';
      if (noGroup) noGroup.style.display = 'block';
      if (groupPanel) groupPanel.style.display = 'none';
      return;
    }

    if (content) content.style.display = 'block';
    if (noGroup) noGroup.style.display = 'none';
    if (groupPanel) groupPanel.style.display = 'block';

    var nameEl = document.getElementById('family-group-name');
    var metaEl = document.getElementById('family-group-meta');
    if (nameEl) nameEl.textContent = group.name || 'My Group';
    if (metaEl) metaEl.textContent = (group.plan || '') + (members.length ? ' · ' + members.length + ' members' : '');

    // Role badge — find current user's role from members list
    var myId = null;
    try { var t = JSON.parse(atob(window._npToken.split('.')[1])); myId = t.sub; } catch(e) {}
    var myMember = members.find(function(m) { return m.user_id === myId; });
    var myRole = (myMember && myMember.role) || (group.owner_id === myId ? 'owner' : '');
    if (myRole && roleBadge) {
      roleBadge.style.display = 'inline-flex';
      roleBadge.innerHTML = '<i class="fas fa-user-shield"></i> ' + myRole;
    }

    // Members list — backend nests profile data in .profiles
    var membersEl = document.getElementById('family-members-list');
    if (membersEl && members.length) {
      membersEl.innerHTML = members.map(function(m) {
        var p = m.profiles || m;
        var name = p.display_name || p.name || p.email || 'Member';
        var role = m.role || '';
        var tier = p.subscription_tier || '';
        return '<div class="family-member-row">' +
          '<div class="family-member-avatar">' + escHtml(name.charAt(0).toUpperCase()) + '</div>' +
          '<div class="family-member-info">' +
            '<span class="family-member-name">' + escHtml(name) + '</span>' +
            '<span class="family-member-meta">' + escHtml(p.email || '') + (role ? ' · ' + role : '') + (tier ? ' · ' + tier : '') + '</span>' +
          '</div>' +
          (role === 'owner' ? '<span class="family-badge-owner"><i class="fas fa-crown"></i></span>' : '') +
        '</div>';
      }).join('');
    }

    // Show invite panel for owners/admins
    var canInvite = myRole === 'owner' || myRole === 'admin' || myRole === 'manager';
    var invitePanel = document.getElementById('family-invite-panel');
    if (invitePanel && canInvite) invitePanel.style.display = 'block';

  } catch(e) {
    if (loading) loading.style.display = 'none';
    if (errorEl) errorEl.style.display = 'block';
  }
}

async function createFamilyGroup() {
  var btn = document.getElementById('create-group-btn');
  var groupName = prompt('Enter a name for your group:');
  if (!groupName) return;
  if (btn) { btn.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> Creating...'; btn.disabled = true; }
  var token = window._npToken;
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';
  try {
    var res = await fetch(API_BASE + '/api/family/create', {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: groupName })
    });
    if (res.ok) { _familyLoaded = false; loadFamilyGroup(); return; }
  } catch(e) {}
  if (btn) { btn.innerHTML = '<i class="fas fa-plus"></i> Create Group'; btn.disabled = false; }
  alert('Could not create group. Please try again.');
}

async function sendFamilyInvite() {
  var emailEl = document.getElementById('family-invite-email');
  var btn = document.getElementById('family-invite-btn');
  var statusEl = document.getElementById('family-invite-status');
  var email = emailEl ? emailEl.value.trim() : '';
  if (!email || !email.includes('@')) {
    if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#ff6b6b'; statusEl.textContent = 'Please enter a valid email address.'; }
    return;
  }
  if (btn) { btn.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> Sending...'; btn.disabled = true; }
  var token = window._npToken;
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';
  try {
    var res = await fetch(API_BASE + '/api/family/invite', {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    });
    if (res.ok) {
      if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#c9a84c'; statusEl.textContent = 'Invite sent to ' + email; }
      if (emailEl) emailEl.value = '';
    } else {
      var err = await res.json().catch(function() { return {}; });
      if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#ff6b6b'; statusEl.textContent = err.detail || 'Failed to send invite.'; }
    }
  } catch(e) {
    if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#ff6b6b'; statusEl.textContent = 'Network error. Please try again.'; }
  }
  if (btn) { btn.innerHTML = '<i class="fas fa-paper-plane"></i> Send Invite'; btn.disabled = false; }
}

// ---- Admin Panel ----
var _adminLoaded = false;
var _adminSearchTimer = null;

function initAdmin() {
  if (_adminLoaded) return;
  loadAdminStats();
  loadAdminRecentSignups();
}

async function loadAdminStats() {
  var token = window._npToken;
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';

  try {
    var apiFetch = window._npApiFetch;
    var res = apiFetch
      ? await apiFetch('/api/admin/stats')
      : await fetch(API_BASE + '/api/admin/stats', { headers: { 'Authorization': 'Bearer ' + token } });

    if (!res.ok) return;
    var stats = await res.json();

    function showStat(skId, contentId, valId, value) {
      var sk = document.getElementById(skId);
      var ct = document.getElementById(contentId);
      var vl = document.getElementById(valId);
      if (sk) sk.style.display = 'none';
      if (ct) ct.style.display = 'block';
      if (vl) vl.textContent = value;
    }

    showStat('astat-users-sk', 'astat-users-content', 'astat-users', (stats.total_users || stats.users || 0).toLocaleString());
    showStat('astat-active-sk', 'astat-active-content', 'astat-active', (stats.active_subscriptions || stats.active_subs || 0).toLocaleString());

    var mrr = stats.mrr || stats.monthly_revenue || stats.revenue || 0;
    var mrrStr = typeof mrr === 'number' ? '$' + mrr.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : String(mrr);
    showStat('astat-revenue-sk', 'astat-revenue-content', 'astat-revenue', mrrStr);
    showStat('astat-today-sk', 'astat-today-content', 'astat-today', (stats.new_today || stats.signups_today || 0).toLocaleString());

    // Tier breakdown
    var breakdown = stats.tier_breakdown || stats.subscriptions_by_tier || stats.by_tier;
    if (breakdown) {
      var breakEl = document.getElementById('admin-tier-breakdown');
      var bdCard = document.getElementById('admin-sub-breakdown');
      if (breakEl && bdCard) {
        bdCard.style.display = 'block';
        var tiers = ['free', 'plus', 'pro', 'team', 'school', 'enterprise'];
        var icons = { free: 'fa-circle', plus: 'fa-star', pro: 'fa-crown', team: 'fa-users', school: 'fa-graduation-cap', enterprise: 'fa-building' };
        var total = Object.values(breakdown).reduce(function(a, b) { return a + (b || 0); }, 0);
        breakEl.innerHTML = tiers.filter(function(t) { return breakdown[t]; }).map(function(t) {
          var count = breakdown[t] || 0;
          var pct = total > 0 ? Math.round((count / total) * 100) : 0;
          return '<div class="admin-tier-row">' +
            '<div class="admin-tier-label"><i class="fas ' + (icons[t] || 'fa-circle') + '"></i> ' + t.charAt(0).toUpperCase() + t.slice(1) + '</div>' +
            '<div class="admin-tier-bar-wrap"><div class="admin-tier-bar" style="width:' + pct + '%"></div></div>' +
            '<div class="admin-tier-count">' + count + ' <span class="admin-tier-pct">(' + pct + '%)</span></div>' +
          '</div>';
        }).join('');
      }
    }

    _adminLoaded = true;
  } catch(e) {}
}

async function loadAdminRecentSignups() {
  var token = window._npToken;
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';
  var loadingEl = document.getElementById('admin-recent-loading');
  var listEl = document.getElementById('admin-recent-list');
  var emptyEl = document.getElementById('admin-recent-empty');

  try {
    var apiFetch = window._npApiFetch;
    var res = apiFetch
      ? await apiFetch('/api/admin/users?limit=10&sort=created_at&order=desc')
      : await fetch(API_BASE + '/api/admin/users?limit=10&sort=created_at&order=desc', { headers: { 'Authorization': 'Bearer ' + token } });

    if (loadingEl) loadingEl.style.display = 'none';
    if (!res.ok) { if (emptyEl) emptyEl.style.display = 'block'; return; }
    var data = await res.json();
    var users = Array.isArray(data) ? data : (data.users || data.items || []);

    if (users.length === 0) { if (emptyEl) emptyEl.style.display = 'block'; return; }
    if (listEl) {
      listEl.style.display = 'block';
      listEl.innerHTML = users.map(function(u) { return renderAdminUserRow(u); }).join('');
    }
  } catch(e) {
    if (loadingEl) loadingEl.style.display = 'none';
    if (emptyEl) emptyEl.style.display = 'block';
  }
}

function adminSearchUsers(query) {
  clearTimeout(_adminSearchTimer);
  if (!query || query.length < 2) {
    var resultsEl = document.getElementById('admin-user-results');
    if (resultsEl) resultsEl.innerHTML = '';
    return;
  }
  _adminSearchTimer = setTimeout(async function() {
    var token = window._npToken;
    var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';
    var resultsEl = document.getElementById('admin-user-results');
    var loadingEl = document.getElementById('admin-user-loading');
    if (loadingEl) loadingEl.style.display = 'block';
    if (resultsEl) resultsEl.innerHTML = '';
    try {
      var apiFetch = window._npApiFetch;
      var res = apiFetch
        ? await apiFetch('/api/admin/users?search=' + encodeURIComponent(query) + '&limit=10')
        : await fetch(API_BASE + '/api/admin/users?search=' + encodeURIComponent(query) + '&limit=10', { headers: { 'Authorization': 'Bearer ' + token } });

      if (loadingEl) loadingEl.style.display = 'none';
      if (!res.ok) return;
      var data = await res.json();
      var users = Array.isArray(data) ? data : (data.users || data.items || []);
      if (resultsEl) {
        resultsEl.innerHTML = users.length
          ? users.map(function(u) { return renderAdminUserRow(u); }).join('')
          : '<div class="dash-empty-state" style="padding:16px 0;"><i class="fas fa-user-slash"></i><p>No users found.</p></div>';
      }
    } catch(e) {
      if (loadingEl) loadingEl.style.display = 'none';
    }
  }, 350);
}

// Security fix (2026-07-02, flagged by security audit): row objects used to be
// JSON.stringify()'d straight into inline onclick="" attributes. display_name/email are
// user-controlled (any user can set their own display_name via PUT /api/auth/me), and
// JSON.stringify's \" escaping means nothing in an HTML attribute context — a quote in
// display_name broke out of the attribute -> stored XSS in the admin's own session (token
// theft). Fix: keep the real objects in a lookup map keyed by id, and only ever put the
// (escaped) id in the DOM via a data-* attribute; handlers look the object up by id.
var _adminUsersById = {};

function renderAdminUserRow(u) {
  var id = u.id || u.user_id || '';
  if (id) _adminUsersById[id] = u;
  var name = u.display_name || u.name || u.email || 'Unknown';
  var tier = u.subscription_tier || u.tier || 'free';
  var date = u.created_at ? new Date(u.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
  var tierClass = 'plan-' + escHtml(tier);
  return '<div class="admin-user-row">' +
    '<div class="admin-user-avatar">' + escHtml(name.charAt(0).toUpperCase()) + '</div>' +
    '<div class="admin-user-info">' +
      '<span class="admin-user-name">' + escHtml(name) + '</span>' +
      '<span class="admin-user-email">' + escHtml(u.email || '') + (date ? ' · ' + date : '') + '</span>' +
    '</div>' +
    '<div class="admin-user-actions">' +
      '<span class="plan-indicator ' + tierClass + '" style="font-size:11px; padding:3px 8px;">' + escHtml(tier.charAt(0).toUpperCase() + tier.slice(1)) + '</span>' +
      '<button class="btn btn-outline btn-sm" style="padding:4px 10px; font-size:12px;" data-user-id="' + escHtml(String(id)) + '" onclick="openEditUserModalById(this.dataset.userId)"><i class="fas fa-pen"></i></button>' +
    '</div>' +
  '</div>';
}

window.openEditUserModalById = function(id) {
  var user = _adminUsersById[id];
  if (user) openEditUserModal(user);
};

function openEditUserModal(user) {
  var modal = document.getElementById('admin-edit-modal');
  var body = document.getElementById('admin-edit-body');
  if (!modal || !body) return;
  var tier = user.subscription_tier || user.tier || 'free';
  body.innerHTML =
    '<div class="admin-edit-row"><label>Name</label><div class="admin-edit-val">' + escHtml(user.display_name || user.name || '-') + '</div></div>' +
    '<div class="admin-edit-row"><label>Email</label><div class="admin-edit-val">' + escHtml(user.email || '-') + '</div></div>' +
    '<div class="admin-edit-row"><label>Subscription Tier</label>' +
      '<select id="admin-edit-tier" class="dash-search-input" style="width:auto;">' +
        ['free','plus','pro','team','school','enterprise'].map(function(t) {
          return '<option value="' + t + '"' + (t === tier ? ' selected' : '') + '>' + t.charAt(0).toUpperCase() + t.slice(1) + '</option>';
        }).join('') +
      '</select>' +
    '</div>' +
    '<div style="margin-top:20px; display:flex; gap:10px;">' +
      '<button class="btn btn-primary btn-sm" onclick="saveAdminUserEdit()"><i class="fas fa-check"></i> Save Changes</button>' +
      '<button class="btn btn-outline btn-sm" onclick="document.getElementById(\'admin-edit-modal\').style.display=\'none\'">Cancel</button>' +
    '</div>' +
    '<div id="admin-edit-status" style="display:none; margin-top:12px; font-size:13px;"></div>';
  modal.style.display = 'flex';
}

async function saveAdminUserEdit(userId) {
  userId = userId || (typeof _adminCurrentUserId !== 'undefined' ? _adminCurrentUserId : null);
  var tierEl = document.getElementById('admin-edit-tier');
  var adminEl = document.getElementById('admin-edit-is-admin');
  var statusEl = document.getElementById('admin-edit-status');
  if (!tierEl || !userId) return;
  var newTier = tierEl.value;
  var token = window._npToken;
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';
  try {
    var payload = { subscription_tier: newTier };
    if (adminEl) payload.is_admin = adminEl.checked;
    var res = await fetch(API_BASE + '/api/admin/users/' + userId, {
      method: 'PUT', // was PATCH — that route doesn't exist, this endpoint is PUT (confirmed w/ backend-dev 2026-07-02; was 405'ing silently before my session too)
      headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (res.ok) {
      if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#c9a84c'; statusEl.textContent = 'Saved successfully.'; }
      setTimeout(function() { document.getElementById('admin-edit-modal').style.display = 'none'; }, 1200);
    } else {
      if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#ff6b6b'; statusEl.textContent = 'Failed to save.'; }
    }
  } catch(e) {
    if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#ff6b6b'; statusEl.textContent = 'Network error.'; }
  }
}

function closeAdminEditModal(e) {
  if (e.target === document.getElementById('admin-edit-modal')) {
    document.getElementById('admin-edit-modal').style.display = 'none';
  }
}

  // ---- Admin: Invite User ----
async function adminInviteUser() {
  var emailEl = document.getElementById('admin-invite-email');
  var tierEl = document.getElementById('admin-invite-tier');
  var statusEl = document.getElementById('admin-invite-status');
  var btn = document.getElementById('admin-invite-btn');
  if (!emailEl || !emailEl.value.trim()) return;
  var email = emailEl.value.trim();
  var tier = tierEl ? tierEl.value : 'free';
  btn.disabled = true;
  btn.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> Sending…';
  statusEl.style.display = 'none';
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';
  var token = window._npToken;
  try {
    var res = await fetch(API_BASE + '/api/admin/users/invite', {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, subscription_tier: tier })
    });
    var data = await res.json().catch(function() { return {}; });
    if (res.ok) {
      statusEl.style.display = 'block';
      statusEl.style.color = '#c9a84c';
      statusEl.textContent = 'Invite sent to ' + email;
      emailEl.value = '';
    } else {
      statusEl.style.display = 'block';
      statusEl.style.color = '#ff6b6b';
      statusEl.textContent = data.detail || data.message || 'Failed to send invite.';
    }
  } catch(e) {
    statusEl.style.display = 'block';
    statusEl.style.color = '#ff6b6b';
    statusEl.textContent = 'Network error.';
  }
  btn.disabled = false;
  btn.innerHTML = '<i class="fas fa-paper-plane"></i> Send Invite';
}
window.adminInviteUser = adminInviteUser;

// ---- Admin: Toggle Bulk Invite Panel ----
function toggleBulkInvite() {
  var panel = document.getElementById('admin-bulk-panel');
  var chevron = document.getElementById('admin-bulk-chevron');
  if (!panel) return;
  var open = panel.style.display !== 'none';
  panel.style.display = open ? 'none' : 'block';
  if (chevron) chevron.style.transform = open ? '' : 'rotate(180deg)';
}
window.toggleBulkInvite = toggleBulkInvite;

// ---- Admin: Bulk Invite ----
async function adminBulkInvite() {
  var textareaEl = document.getElementById('admin-bulk-emails');
  var tierEl = document.getElementById('admin-bulk-tier');
  var statusEl = document.getElementById('admin-bulk-status');
  var btn = document.getElementById('admin-bulk-btn');
  if (!textareaEl || !textareaEl.value.trim()) return;
  var emails = textareaEl.value.split(/[\s,]+/).map(function(e) { return e.trim(); }).filter(function(e) { return e.includes('@'); });
  if (!emails.length) return;
  var tier = tierEl ? tierEl.value : 'free';
  btn.disabled = true;
  btn.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> Inviting…';
  statusEl.style.display = 'none';
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';
  var token = window._npToken;
  try {
    var res = await fetch(API_BASE + '/api/admin/users/bulk-invite', {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ emails: emails, subscription_tier: tier })
    });
    var data = await res.json().catch(function() { return {}; });
    if (res.ok) {
      var created = data.created || data.success_count || 0;
      var failed = data.failed || data.error_count || 0;
      // bulk-invite grants the tier to EXISTING accounts only — it does not create new ones.
      // Emails that haven't registered yet come back in data.results as status:"not_found",
      // so surface those explicitly rather than lumping them into an opaque "failed" count.
      var results = Array.isArray(data.results) ? data.results : [];
      var notFound = results.filter(function(r) { return r && r.status === 'not_found'; }).map(function(r) { return r.email; }).filter(Boolean);
      statusEl.style.display = 'block';
      statusEl.style.color = '#c9a84c';
      var msg = created + ' invited' + (failed ? ', ' + failed + ' failed' : '') + '.';
      if (notFound.length) msg += ' Not registered yet (need to sign up first): ' + notFound.join(', ') + '.';
      statusEl.textContent = msg;
      if (!failed) textareaEl.value = '';
    } else {
      // Fails gracefully here whether the endpoint 404s (not deployed yet), the body isn't
      // JSON, or detail comes back as a pydantic validation array instead of a string.
      statusEl.style.display = 'block';
      statusEl.style.color = '#ff6b6b';
      statusEl.textContent = (typeof data.detail === 'string' && data.detail) || data.message || 'Bulk invite failed.';
    }
  } catch(e) {
    statusEl.style.display = 'block';
    statusEl.style.color = '#ff6b6b';
    statusEl.textContent = 'Network error.';
  }
  btn.disabled = false;
  btn.innerHTML = '<i class="fas fa-paper-plane"></i> Invite All';
}
window.adminBulkInvite = adminBulkInvite;

// ---- Admin: Enhanced openEditUserModal with modes + activity ----
var _adminCurrentUserId = null;
var _adminActivityOffset = 0;
var _adminActivityAllLogs = [];

function openEditUserModal(user) {
  _adminCurrentUserId = user.id || user.user_id || null;
  _adminActivityOffset = 0;
  _adminActivityAllLogs = [];
  var modal = document.getElementById('admin-edit-modal');
  var body = document.getElementById('admin-edit-body');
  if (!modal || !body) return;
  var tier = user.subscription_tier || user.tier || 'free';
  body.innerHTML =
    '<div class="admin-edit-row"><label>Name</label><div class="admin-edit-val">' + escHtml(user.display_name || user.name || '-') + '</div></div>' +
    '<div class="admin-edit-row"><label>Email</label><div class="admin-edit-val">' + escHtml(user.email || '-') + '</div></div>' +
    '<div class="admin-edit-row"><label>Subscription Tier</label>' +
      '<select id="admin-edit-tier" class="dash-search-input" style="width:auto;">' +
        ['free','plus','pro','team','school','enterprise'].map(function(t) {
          return '<option value="' + t + '"' + (t === tier ? ' selected' : '') + '>' + t.charAt(0).toUpperCase() + t.slice(1) + '</option>';
        }).join('') +
      '</select>' +
    '</div>' +
    '<div class="admin-edit-row"><label>Admin Access</label>' +
      '<label class="admin-mode-checkbox-label" style="margin-top:4px;">' +
        '<input type="checkbox" id="admin-edit-is-admin"' + (user.is_admin ? ' checked' : '') + '>' +
        '<span class="admin-mode-checkbox-custom"></span> Grant admin access' +
      '</label>' +
    '</div>' +
    '<div style="margin-top:20px; display:flex; gap:10px;">' +
      '<button class="btn btn-primary btn-sm" onclick="saveAdminUserEdit()"><i class="fas fa-check"></i> Save Changes</button>' +
      '<button class="btn btn-outline btn-sm" onclick="document.getElementById(\'admin-edit-modal\').style.display=\'none\'">Cancel</button>' +
    '</div>' +
    '<div id="admin-edit-status" style="display:none; margin-top:12px; font-size:13px;"></div>';

  // Show modes & activity sections
  var modesSection = document.getElementById('admin-modes-section');
  var activitySection = document.getElementById('admin-activity-section');
  if (modesSection) {
    modesSection.style.display = _adminCurrentUserId ? 'block' : 'none';
    // Reset modes UI
    var allCb = document.getElementById('admin-mode-all');
    if (allCb) allCb.checked = false;
    document.querySelectorAll('.admin-mode-cb').forEach(function(cb) { cb.checked = false; cb.disabled = false; });
    var modeStatusEl = document.getElementById('admin-modes-status');
    if (modeStatusEl) modeStatusEl.style.display = 'none';
    // Populate from user data if available
    if (user.modes === null || user.modes === undefined) {
      if (allCb) { allCb.checked = true; adminToggleAllModes(true); }
    } else if (Array.isArray(user.modes)) {
      document.querySelectorAll('.admin-mode-cb').forEach(function(cb) {
        cb.checked = user.modes.indexOf(cb.value) !== -1;
      });
    }
  }
  if (activitySection) {
    activitySection.style.display = _adminCurrentUserId ? 'block' : 'none';
    var activityList = document.getElementById('admin-activity-list');
    var activityLoading = document.getElementById('admin-activity-loading');
    var activityMore = document.getElementById('admin-activity-more-wrap');
    var activityBtn = document.getElementById('admin-view-activity-btn');
    if (activityList) { activityList.style.display = 'none'; activityList.innerHTML = ''; }
    if (activityLoading) activityLoading.style.display = 'none';
    if (activityMore) activityMore.style.display = 'none';
    if (activityBtn) activityBtn.style.display = 'inline-flex';
  }

  modal.style.display = 'flex';
}
window.openEditUserModal = openEditUserModal;

// ---- Admin: Toggle All Modes ----
function adminToggleAllModes(checked) {
  document.querySelectorAll('.admin-mode-cb').forEach(function(cb) {
    cb.checked = false;
    cb.disabled = checked;
  });
}
window.adminToggleAllModes = adminToggleAllModes;

// ---- Admin: Save Modes ----
async function adminSaveModes() {
  var userId = _adminCurrentUserId;
  if (!userId) return;
  var allCb = document.getElementById('admin-mode-all');
  var statusEl = document.getElementById('admin-modes-status');
  var btn = document.getElementById('admin-save-modes-btn');
  var modes = null;
  if (!allCb || !allCb.checked) {
    modes = [];
    document.querySelectorAll('.admin-mode-cb').forEach(function(cb) {
      if (cb.checked) modes.push(cb.value);
    });
  }
  btn.disabled = true;
  btn.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> Saving…';
  if (statusEl) statusEl.style.display = 'none';
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';
  var token = window._npToken;
  try {
    var res = await fetch(API_BASE + '/api/admin/users/' + userId + '/modes', {
      method: 'PUT',
      headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ modes: modes })
    });
    if (res.ok) {
      if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#c9a84c'; statusEl.textContent = 'Modes saved.'; }
    } else {
      var data = await res.json().catch(function() { return {}; });
      if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#ff6b6b'; statusEl.textContent = data.detail || 'Failed to save modes.'; }
    }
  } catch(e) {
    if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#ff6b6b'; statusEl.textContent = 'Network error.'; }
  }
  btn.disabled = false;
  btn.innerHTML = '<i class="fas fa-check"></i> Save Modes';
}
window.adminSaveModes = adminSaveModes;

// ---- Admin: Load Activity ----
async function adminLoadActivity(loadMore) {
  var userId = _adminCurrentUserId;
  if (!userId) return;
  if (!loadMore) { _adminActivityOffset = 0; _adminActivityAllLogs = []; }
  var listEl = document.getElementById('admin-activity-list');
  var loadingEl = document.getElementById('admin-activity-loading');
  var moreWrap = document.getElementById('admin-activity-more-wrap');
  var viewBtn = document.getElementById('admin-view-activity-btn');
  if (loadingEl) loadingEl.style.display = 'block';
  if (viewBtn) viewBtn.style.display = 'none';
  if (moreWrap) moreWrap.style.display = 'none';
  var API_BASE = window._npApiBase || 'https://neuropen-backend.onrender.com';
  var token = window._npToken;
  try {
    var res = await fetch(API_BASE + '/api/admin/users/' + userId + '/activity', {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    if (!res.ok) throw new Error('Failed');
    var data = await res.json();
    var logs = data.usage_logs || [];
    _adminActivityAllLogs = _adminActivityAllLogs.concat(logs);
    var page = _adminActivityAllLogs.slice(0, _adminActivityOffset + 20);
    _adminActivityOffset = page.length;
    if (listEl) {
      listEl.style.display = 'block';
      if (!loadMore) listEl.innerHTML = '';
      if (page.length === 0) {
        listEl.innerHTML = '<div style="color:#666; font-size:13px; padding:8px 0;">No activity found.</div>';
      } else {
        var html = page.map(function(log) {
          var date = log.created_at ? new Date(log.created_at).toLocaleDateString() : '-';
          var mode = log.mode || '-';
          var qtype = log.query_type || log.type || '-';
          var tokens = log.tokens_used || log.tokens || '-';
          return '<div class="admin-activity-row">' +
            '<span class="admin-activity-date">' + escHtml(date) + '</span>' +
            '<span class="admin-activity-mode">' + escHtml(mode) + '</span>' +
            '<span class="admin-activity-type"><i class="fas ' + (qtype === 'voice' ? 'fa-microphone' : 'fa-keyboard') + '"></i> ' + escHtml(qtype) + '</span>' +
            '<span class="admin-activity-tokens">' + escHtml(String(tokens)) + ' tok</span>' +
          '</div>';
        }).join('');
        if (loadMore) listEl.innerHTML += html;
        else listEl.innerHTML = html;
        if (_adminActivityAllLogs.length > _adminActivityOffset) {
          if (moreWrap) moreWrap.style.display = 'block';
        }
      }
    }
  } catch(e) {
    if (listEl) { listEl.style.display = 'block'; listEl.innerHTML = '<div style="color:#ff6b6b; font-size:13px;">Failed to load activity.</div>'; }
  }
  if (loadingEl) loadingEl.style.display = 'none';
}
window.adminLoadActivity = adminLoadActivity;

  // ---- Smart sticky buy bar show/hide ----
  var buyBar = document.querySelector('.sticky-buy-bar');
  if (buyBar) {
    var heroSection = document.querySelector('.hero');
    var footerSection = document.querySelector('footer');
    window.addEventListener('scroll', function() {
      var scrollY = window.scrollY;
      var heroBottom = heroSection ? heroSection.offsetTop + heroSection.offsetHeight : 600;
      var footerTop = footerSection ? footerSection.offsetTop - window.innerHeight : Infinity;
      if (scrollY > heroBottom && scrollY < footerTop) {
        buyBar.classList.remove('hidden');
      } else {
        buyBar.classList.add('hidden');
      }
    }, { passive: true });
  }

/* ── Nexus Pen waitlist capture (site-wide) ──────────────────────────
   Warm-up: wake the Render backend on page load so a signup never waits
   on a cold start (they felt ~10s before this). Submit: optimistic — the
   UI confirms instantly and the request rides keepalive so it survives
   navigation away from the page. */
(function () {
  var NP_API = 'https://neuropen-backend.onrender.com';
  try { fetch(NP_API + '/api/ping', { mode: 'cors' }).catch(function () {}); } catch (e) {}
  window.npJoinWaitlist = function (email, source) {
    // Joining ANYWHERE (hero, footer, demo) also suppresses the newsletter
    // popup -- same key newsletter-popup.liquid checks before showing.
    try { localStorage.setItem('np_nl_dismissed', '1'); } catch (e) {}
    try {
      fetch(NP_API + '/api/waitlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, source: source || 'site' }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  };
})();

/* ── Navbar / announcement-bar offset ────────────────────────────────
   The navbar is position:fixed at the top while the announcement bar is a
   normal in-flow element above it — so at scroll-top the bar covered the
   navbar (fully, on phones, where the bar text wraps two lines and the
   hamburger became untappable). Keep the navbar pinned just below the
   visible part of the bar; returns to top:0 as the bar scrolls away or is
   dismissed. */
(function () {
  var root = document.documentElement;
  var raf = null;
  function bar() {
    return document.querySelector('.announcement-bar') ||
           document.querySelector('[id^="shopify-section-announcement"]');
  }
  function sync() {
    raf = null;
    var b = bar();
    var offset = 0;
    if (b && b.offsetParent !== null) {
      var r = b.getBoundingClientRect();
      if (r.bottom > 0 && r.height > 0) offset = r.bottom;
    }
    root.style.setProperty('--np-announce-offset', offset + 'px');
  }
  function queue() { if (!raf) raf = requestAnimationFrame(sync); }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  document.addEventListener('click', function () { setTimeout(queue, 50); }, true);
  sync();
  setTimeout(sync, 300);
})();
